// Set --header-height CSS variable so hero can fill the remaining viewport
const header = document.querySelector("header.header");
if (header) {
  const setHeaderHeight = () => {
    document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
}
